import { render, staticRenderFns } from "./FormAccessRequestReportGDS.vue?vue&type=template&id=77662832&lang=pug"
import script from "./FormAccessRequestReportGDS.vue?vue&type=script&lang=js"
export * from "./FormAccessRequestReportGDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77662832')) {
      api.createRecord('77662832', component.options)
    } else {
      api.reload('77662832', component.options)
    }
    module.hot.accept("./FormAccessRequestReportGDS.vue?vue&type=template&id=77662832&lang=pug", function () {
      api.rerender('77662832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/FormAccessRequestReportGDS.vue"
export default component.exports